import { message } from 'antd';
import { getWechatConfig } from '../services/h5Api';

export default {
  namespace: 'h5',

  state: {
    config: {}
  },
  effects: {
    *getWechatConfig({ payload }, { call, put }) {
      const result = yield call(getWechatConfig, payload.data);
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              config: result.data
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
      return result;
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    }
  }
};

